import { render, staticRenderFns } from "./editTrainProgram.vue?vue&type=template&id=3c8df3ac&scoped=true"
import script from "./editTrainProgram.vue?vue&type=script&lang=js"
export * from "./editTrainProgram.vue?vue&type=script&lang=js"
import style0 from "./editTrainProgram.vue?vue&type=style&index=0&id=3c8df3ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8df3ac",
  null
  
)

export default component.exports